



















import {Component, Mixins, Prop, Watch} from 'vue-property-decorator'
import ContactWayPicker from '@/components/contact/ContactWayPicker.vue'
import {ContactWayOption, IContactWayOption, IContactWayOptionData, JustifyDirection} from '@/components/lib/models'
import {updateItems} from '@/lib'
import {IContactWay, CONTACT_VALUE_MAX_LENGTH} from '@/entities'
import onLocaleChangeMixin from '@/mixins/onLocaleChangeMixin'
import {Theme} from '@/store'
const InputCommon = () => import('@/components/lib/InputCommon.vue')

@Component({
  components: {
    ContactWayPicker,
    InputCommon
  }
})
export default class ContactPicker extends Mixins(onLocaleChangeMixin) {
  @Prop() readonly theme?: Theme;
  @Prop({ default: () => ([])}) readonly options?: number[];
  @Prop({ default: 'left' }) readonly justify?: JustifyDirection;
  @Prop({ default: false }) readonly withValue?: boolean;
  @Prop ({default: false}) readonly SelectColor?: boolean;
  @Prop() readonly value?: string;

  get CONTACT_VALUE_MAX_LENGTH(): number {
    return CONTACT_VALUE_MAX_LENGTH;
  }

  get contactValue(): string {
    return this.value || '';
  }
  set contactValue(value: string) {
    this.$emit('input', value);
  }

  get justifyClass(): { text: string, block: string } {
    let resBlock = 'justify-content-';
    let resText = 'text-align-';
    let dir: string;
    switch (this.justify) {
      case "left":
        dir = 'start';
        break;
      case "right":
        dir = 'end';
        break;
      default:
        dir = 'center';
    }
    return {
      block: resBlock + dir,
      text: resText + dir
    }
  }

  protected initFetches = [
    this.fetchContactWays
  ];

  protected reFetches = [
    this.updateContactWays
  ];

  protected fetching: boolean = false;

  private contactWays: IContactWay[] = [];
  private contactWayChoice: IContactWayOption[] = [];

  get contactWayOptions(): IContactWayOption[] {
    return this.contactWayChoice;
  }
  set contactWayOptions(newWays: IContactWayOption[]) {
    newWays.forEach((newWay: IContactWayOption) => {
      let wayField = this.contactWayChoice.find((way: IContactWayOption) => way.key === newWay.key);
      if (wayField) {
        wayField.value = newWay.value;
      }
    })
  }

  get selectedContactWayIds(): number[] {
    return this.contactWayChoice.filter((way: IContactWayOption) => way.value).map((way: IContactWayOption) => way.id || 0);
  }

  get contactWaysToShow(): IContactWay[] {
    return this.contactWays.filter((way: IContactWay) => way.validate());
  }

  private fetchContactWays(): void {
    this.fetching = true;
    this.$storage.actions.fetchContactWays()
      .then(res => {
        this.contactWays = res;
        this.contactWayChoice = this.contactWaysToShow.map((way: IContactWayOptionData) => new ContactWayOption({
          ...way,
          value: way?.id ? (this.options?.indexOf(way.id) !== -1) : false
        }))
      })
      .catch(() => {})
      .finally(() => {
        this.fetching = false;
      })
  }

  private updateContactWays(): void {
    updateItems<IContactWayOption>(this.contactWayChoice, this.$storage.actions.getContactWayById);
  }

  public reset(): void {
    this.contactWayOptions.forEach((way: IContactWayOption) => {
      way.value = false;
    });
  }

  @Watch('selectedContactWayIds')
  onSelectedContactWayIdsChanged(): void {
    this.$emit('update:options', this.selectedContactWayIds)
  }

}
